import React from 'react'
import GlobalStorage from '../storage/GlobalStorage'
import { Button,ButtonGroup} from 'reactstrap';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faArrowsAltV,faEdit,faTrashAlt,faAlignLeft,faAlignCenter,faAlignRight,faBook,faComments,faImage} from '@fortawesome/free-solid-svg-icons'



export default class extends React.Component
{
  constructor(props)
  {
    super(props);
    this.state = {}
    this.GS = new GlobalStorage();
    this.onChangeItem = this.onChangeItem.bind(this);
  }

  onChangeItem()
  {
    this.props.onChangeItem && this.props.onChangeItem();    
  }

  render()
  {
    var opacity = this.props.opacity || 1;
    var isSelected = this.props.isSelected || false;
    var isAllowEdit = this.props.isAllowEdit || false;
        
    
    var position = this.props.item.hasOwnProperty('_attributes') ? (this.props.item._attributes.position) : (this.props.item.type==='Scene')? 'center':false;
    var isScene = this.props.item.type==='Scene';
    
    return (
        <div id={`card-`+(this.props.index)} className={`item`}>
          <div className={`storycard ${isSelected && `selected`} ${position=='left'?(`text-left`):``} ${position=='right'?(`text-right`):``} ${position=='center'?(`text-center`):``}`} style={Object.assign({}, this.props.style, { opacity },)}
            onClick={(e) => {
              e.stopPropagation();
              this.props.onSelect && this.props.onSelect();
            }}
          >
              {this.props.children} 
              {isSelected?(
                <div className={`${position=='left'?(`text-left`):``} ${position=='right'?(`text-right`):``} ${position=='center'?(`text-center`):``} mt-3`}>
                    <span style={{width: `40px`}} className={`text-center d-inline-block`} onClick={(e) => {
                      e.stopPropagation();
                      this.props.onShiftOrder && this.props.onShiftOrder();
                    }}>
                      <FontAwesomeIcon icon={faArrowsAltV} size="lg" title="移動次序"/>
                    </span>

                    <span style={{width: `40px`}} className={`text-center d-inline-block`} onClick={(e) => {
                      e.stopPropagation();
                      this.props.onRemove && this.props.onRemove();
                    }}>
                      <FontAwesomeIcon icon={faTrashAlt} size="lg" title="刪除"/>
                    </span>

                    {
                      isAllowEdit && position=='left' ? (
                          <span style={{width: `40px`}} className={`text-center d-inline-block`} onClick={(e) => {
                            e.stopPropagation();
                            this.props.onShiftAlign && this.props.onShiftAlign();
                          }}>
                            <FontAwesomeIcon icon={faAlignCenter} size="lg" title="置中"/>
                          </span>
                      ) : (
                        null
                      )
                    }

                    { //disable this for Narrative
                      isAllowEdit && position=='center' ? (
                          <span style={{width: `40px`}} className={`text-center d-inline-block`} onClick={(e) => {
                            e.stopPropagation();
                            this.props.onShiftAlign && this.props.onShiftAlign();
                          }}>
                            <FontAwesomeIcon icon={faAlignRight} size="lg" title="置右"/>
                          </span>
                      ) : (
                        null
                      )
                    }

                      {   
                      isAllowEdit && position=='right' ? (
                          <span style={{width: `40px`}} className={`text-center d-inline-block`} onClick={(e) => {
                            e.stopPropagation();
                            this.props.onShiftAlign && this.props.onShiftAlign();
                          }}>
                            <FontAwesomeIcon icon={faAlignLeft} size="lg" title="置左"/>
                          </span>
                      ) : (
                        null
                      )
                    }


                    <ButtonGroup className="mr-auto">
                      <div class="input-group-prepend">
                        <div class="input-group-text" style={{color: "#ffffff",backgroundColor:"#6c757d",border: "1px solid #6c757d"}}>加插元素</div>
                      </div>        
                      <Button onClick={(e) => {e.stopPropagation();this.GS.addStoryEpisodeItem("Scene",this.props.index+1);this.onChangeItem()}}>
                        <FontAwesomeIcon icon={faBook} size="lg" title="新增分頁"/>
                      </Button>
                      <Button onClick={(e) => {e.stopPropagation();this.GS.addStoryEpisodeItem("Narrative",this.props.index+1);this.onChangeItem()}}>
                        <FontAwesomeIcon icon={faAlignCenter} size="lg" title="新增旁白"/>
                      </Button>
                      <Button onClick={(e) => {e.stopPropagation();this.GS.addStoryEpisodeItem("Text",this.props.index+1);this.onChangeItem()}}>
                        <FontAwesomeIcon icon={faComments} size="lg" title="新增對話"/>
                      </Button>
                      <Button onClick={(e) => {e.stopPropagation();this.GS.addStoryEpisodeItem("Media",this.props.index+1);this.onChangeItem()}}>
                        <FontAwesomeIcon icon={faImage} size="lg" title="新增媒體"/>
                      </Button>
                    </ButtonGroup>           
                </div>
              ):null}                            
          </div>                   
        </div>
    )
  }
}